var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInitializing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_initializing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Windows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Single-page-4--1-icons",
    transform: "translate(-357.000000, -524.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_initializing",
    transform: "translate(357.000000, 524.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5697B7",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0002,12.0033389 L14.0002,14.9983306 C14.0002,15.5515373 14.4479153,16 15.0002,16 C15.5524847,16 16.0002,15.5515373 16.0002,14.9983306 L16.0002,11.1018364 C16.0002,10.4935378 15.5074847,10 14.9002,10 L11.0002,10 C10.4479153,10 10.0002,10.4484627 10.0002,11.0016694 C10.0002,11.5548762 10.4479153,12.0033389 11.0002,12.0033389 L14.0002,12.0033389 Z",
    id: "Stroke-1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4283997,24.0178142 C13.3514797,22.9894079 12,20.8070226 12,18.3703101 C12,16.1043817 13.1675307,14.0511676 15.0211152,12.9452221 C15.5003242,12.659301 15.6662337,12.0229497 15.3916845,11.5238916 C15.1171354,11.0248336 14.5060937,10.852052 14.0268848,11.1379732 C11.5573637,12.6114186 10,15.3501913 10,18.3703101 C10,21.6184958 11.8020611,24.5284854 14.5696003,25.8988582 C15.0683768,26.145832 15.6649637,25.9249578 15.9021146,25.4055218 C16.1392655,24.8860858 15.9271761,24.264788 15.4283997,24.0178142 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002,21.0016694 L20.0002,24.8981636 C20.0002,25.506177 20.4932,26 21.1002,26 L25.0002,26 C25.5532,26 26.0002,25.5512521 26.0002,24.9983306 C26.0002,24.445409 25.5532,23.9966611 25.0002,23.9966611 L22.0002,23.9966611 L22.0002,21.0016694 C22.0002,20.4477462 21.5522,20 21.0002,20 C20.4482,20 20.0002,20.4477462 20.0002,21.0016694 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.097237,10.5956553 C19.860237,11.1152916 20.072237,11.7359394 20.571237,11.9827407 C22.648237,13.0115998 23.999237,15.1932394 23.999237,17.630011 C23.999237,19.8960003 22.832237,21.9495532 20.978237,23.0554726 C20.499237,23.340804 20.333237,23.9770721 20.608237,24.4758813 C20.882237,24.9757319 21.493237,25.1475556 21.972237,24.8622242 C24.442237,23.3887063 25.999237,20.6499416 25.999237,17.630011 C25.999237,14.3820235 24.197237,11.4724765 21.429237,10.1020528 C21.291237,10.0333234 21.145237,10 21.002237,10 C20.628237,10 20.269237,10.2207673 20.097237,10.5956553 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInitializing);
export default __webpack_public_path__ + "static/media/icon_initializing.4fafbda16c37a232452050338d0f2556.svg";
export { ForwardRef as ReactComponent };